export enum Employee {
  GET_EMPLOYEE_REQUEST = '@employee/GET_EMPLOYEE_REQUEST',
  GET_EMPLOYEE_SUCCESS = '@employee/GET_EMPLOYEE_SUCCESS',
  GET_EMPLOYEE_FAIL = '@employee/GET_EMPLOYEE_FAIL',

  ADD_EMPLOYEE_REQUEST = '@employee/ADD_EMPLOYEE_REQUEST',
  ADD_EMPLOYEE_SUCCESS = '@employee/ADD_EMPLOYEE_SUCCESS',
  ADD_EMPLOYEE_FAIL = '@employee/ADD_EMPLOYEE_FAIL',

  UPDATE_EMPLOYEE_REQUEST = '@employee/UPDATE_EMPLOYEE_REQUEST',
  UPDATE_EMPLOYEE_SUCCESS = '@employee/UPDATE_EMPLOYEE_SUCCESS',
  UPDATE_EMPLOYEE_FAIL = '@employee/UPDATE_EMPLOYEE_FAIL',

  ADD_EMPLOYEE_TO_SITE_REQUEST = '@employee/ADD_EMPLOYEE_TO_SITE_REQUEST',
  ADD_EMPLOYEE_TO_SITE_SUCCESS = '@employee/ADD_EMPLOYEE_TO_SITE_SUCCESS',
  ADD_EMPLOYEE_TO_SITE_FAIL = '@employee/ADD_EMPLOYEE_TO_SITE_FAIL',

  REMOVE_EMPLOYEE_FROM_SITE_REQUEST = '@employee/REMOVE_EMPLOYEE_FROM_SITE_REQUEST',
  REMOVE_EMPLOYEE_FROM_SITE_SUCCESS = '@employee/REMOVE_EMPLOYEE_FROM_SITE_SUCCESS',
  REMOVE_EMPLOYEE_FROM_SITE_FAIL = '@employee/REMOVE_EMPLOYEE_FROM_SITE_FAIL',

  UPDATE_EMPLOYEE_SITE_ROLE_REQUEST = '@employee/UPDATE_EMPLOYEE_SITE_ROLE_REQUEST',
  UPDATE_EMPLOYEE_SITE_ROLE_SUCCESS = '@employee/UPDATE_EMPLOYEE_SITE_ROLE_SUCCESS',
  UPDATE_EMPLOYEE_SITE_ROLE_FAIL = '@employee/UPDATE_EMPLOYEE_SITE_ROLE_FAIL',

  GET_EMPLOYEE_CARD_REQUEST = '@employee/GET_EMPLOYEE_CARD_REQUEST',
  GET_EMPLOYEE_CARD_SUCCESS = '@employee/GET_EMPLOYEE_CARD_SUCCESS',
  GET_EMPLOYEE_CARD_FAIL = '@employee/GET_EMPLOYEE_CARD_FAIL',

  DELETE_EMPLOYEE_REQUEST = '@employee/DELETE_EMPLOYEE_REQUEST',
  DELETE_EMPLOYEE_SUCCESS = '@employee/DELETE_EMPLOYEE_SUCCESS',
  DELETE_EMPLOYEE_FAIL = '@employee/DELETE_EMPLOYEE_FAIL',
}
